"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var CurrencyRuble = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "currency-ruble" },
            react_1.default.createElement("path", { id: "Icon", d: "M8.5 3.5V2.5C7.94772 2.5 7.5 2.94772 7.5 3.5H8.5ZM6.5 10.5C5.94772 10.5 5.5 10.9477 5.5 11.5C5.5 12.0523 5.94772 12.5 6.5 12.5V10.5ZM13.5 16.5C14.0523 16.5 14.5 16.0523 14.5 15.5C14.5 14.9477 14.0523 14.5 13.5 14.5V16.5ZM6.5 14.5C5.94772 14.5 5.5 14.9477 5.5 15.5C5.5 16.0523 5.94772 16.5 6.5 16.5V14.5ZM9.5 4C9.5 3.44772 9.05228 3 8.5 3C7.94772 3 7.5 3.44772 7.5 4H9.5ZM7.5 20.5C7.5 21.0523 7.94772 21.5 8.5 21.5C9.05228 21.5 9.5 21.0523 9.5 20.5H7.5ZM8.5 4.5H14.5V2.5H8.5V4.5ZM14.5 10.5H8.5V12.5H14.5V10.5ZM17.5 7.5C17.5 9.15685 16.1569 10.5 14.5 10.5V12.5C17.2614 12.5 19.5 10.2614 19.5 7.5H17.5ZM14.5 4.5C16.1569 4.5 17.5 5.84315 17.5 7.5H19.5C19.5 4.73858 17.2614 2.5 14.5 2.5V4.5ZM8.5 10.5H6.5V12.5H8.5V10.5ZM13.5 14.5H6.5V16.5H13.5V14.5ZM7.5 4V20.5H9.5V4H7.5ZM9.5 11.5V3.5H7.5V11.5H9.5Z" }))));
};
exports.default = CurrencyRuble;
